import { createApi } from '@reduxjs/toolkit/query/react';
import Cookies from 'js-cookie';
import { axiosBaseQuery } from 'services/_infra/rtkBaseQuery';

export const alertsApi = createApi({
  reducerPath: 'alertsApi', // This is the name of the slice in the store
  baseQuery: axiosBaseQuery(), // Custom axios base query (calls apiClient with the query url and params)
  tagTypes: ['Alert'], // Used to track when refetches are needed
  endpoints: (builder) => ({
    getAllActiveAlerts: builder.query({
      query: () => ({
        url: '/getAllActiveAlerts',
      }),
      transformResponse: (response) => response.alerts, // Extract the alerts array from the response
      providesTags: ['Alert'], // Tells RTK Query this query provides 'Alert' data and to refetch when invalidated
    }),
    postAlert: builder.mutation({
      query: (alert) => ({
        url: '/InsertFusionAlerts',
        method: 'POST',
        data: {
          polygon: alert.coordinates,
          city: alert.city,
          state: alert.state,
          broadcastTime: new Date().toISOString(),
          issuedTime: alert.issuedTime,
          expirationTime: alert.expirationTime,
          severity: alert.severity,
          headline: alert.headline,
          description: alert.description,
          type: alert.type,
          isInternalUse: alert.isInternalUse,
        },
      }),
      invalidatesTags: ['Alert'], // Tells RTK Query to refetch any queries that provide this tag
    }),
    getCWActiveAlerts: builder.query({
      query: () => ({
        url: '/getCWActiveAlerts',
        method: 'POST',
        data: { latitude: Cookies.get('latitude'), longitude: Cookies.get('longitude') },
      }),
      providesTags: ['Alert'], // Tells RTK Query this query provides 'Alert' data and to refetch when invalidated
    }),
    setAlertEnd: builder.mutation({
      query: ({ alertId, workplaceId }) => ({
        url: '/setAlertEnd',
        method: 'POST',
        data: {
          alertId,
          workplaceId,
        },
      }),
      invalidatesTags: ['Alert'], // Tells RTK Query to refetch any queries that provide this tag
    }),
  }),
});

export const {
  useGetAllActiveAlertsQuery,
  usePostAlertMutation,
  useGetCWActiveAlertsQuery,
  useSetAlertEndMutation,
} = alertsApi;
